export default "__VITE_ASSET__CY2cyWsA__"